import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#0052B4\" d=\"M17.822 1.505A11.95 11.95 0 0 0 12 0C5.373 0 0 5.372 0 11.999l8.348-4.173zM0 12.002C0 18.629 5.373 24 12 24c2.113 0 4.097-.546 5.822-1.505l-9.474-6.32z\"></path><path fill=\"#D80027\" d=\"M18.822 2.127q-.485-.334-1-.622L0 11.998v.003l17.821 10.493q.517-.287 1-.622L2.055 12z\"></path><path fill=\"#A2001D\" d=\"M20.87 11.553h-1.43a1.135 1.135 0 0 0-.07-1.53 1.136 1.136 0 0 0 0-1.605l-.027.026c.444-.443.47-1.189.027-1.632l-6.425 6.424a1.12 1.12 0 0 0 1.594-.005l.123-.113 3.077-.28v1.323h1.043v-1.418l1.566-.142z\"></path><path fill=\"#FFDA44\" d=\"M13.044 14.609 12 14.087l1.044-.522h6.782v1.044z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }